import { render, staticRenderFns } from "./CategoryChildren.vue?vue&type=template&id=3fee29e5"
import script from "./CategoryChildren.vue?vue&type=script&lang=js"
export * from "./CategoryChildren.vue?vue&type=script&lang=js"
import style0 from "./CategoryChildren.vue?vue&type=style&index=0&id=3fee29e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports